import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "c-common-heading1__button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("h1", {
    class: _normalizeClass(["c-common-heading1", { '-block-large-sp': _ctx.blockLargeSp }])
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.$slots.text)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "text", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.button)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "button", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}